import React, { useMemo } from "react";
import { calculateProfileInsights } from "../../../Utils/candidate-analytics.utils";
import {
  SendOutlined,
  AimOutlined,
  ThunderboltOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { JobApplication } from "../../../Entities/job-application.entity";

interface ApplicationStatsCardsProps {
  applications: JobApplication[];
}

const ApplicationStatsCards: React.FC<ApplicationStatsCardsProps> = ({applications}) => {

  const profileInsights = useMemo(
    () => calculateProfileInsights(applications),
    [applications],
  );

  const totalApplicationsCount = applications.length;
  const totalHiredApplicationsCount = applications.filter(
    (a) => a.status === "hired",
  ).length;

  const profileMatchRate = `${profileInsights.qualificationRate}%`;
  const averageProfileMatchScore = profileInsights.averageScore;

  const statCards = [
    {
      icon: <SendOutlined />,
      color: "blue",
      badge: "+12%",
      badgeType: "success",
      value: totalApplicationsCount,
      label: "Total Applications",
    },
    {
      icon: <AimOutlined />,
      color: "purple",
      badge: "Optimal",
      badgeType: "success",
      value: profileMatchRate,
      label: "Profile Match Rate",
    },
    {
      icon: <ThunderboltOutlined />,
      color: "amber",
      badge: "Avg",
      badgeType: "neutral",
      value: averageProfileMatchScore,
      label: "Avg Match Score",
    },
    {
      icon: <SafetyCertificateOutlined />,
      color: "emerald",
      badge: "New!",
      badgeType: "success",
      value: totalHiredApplicationsCount,
      label: "Hired Offers",
    },
  ];

  return (
    <section className="profile__stats">
      {statCards.map((stat, i) => (
        <div key={i} className="profile__stat-card">
          <div className="profile__stat-card-top">
            <div
              className={`profile__stat-icon profile__stat-icon--${stat.color}`}
            >
              {stat.icon}
            </div>
            {/* <span
              className={`profile__stat-badge profile__stat-badge--${stat.badgeType}`}
            >
              {stat.badge}
            </span> */}
          </div>
          <p className="profile__stat-value">{stat.value}</p>
          <p className="profile__stat-label">{stat.label}</p>
        </div>
      ))}
    </section>
  );
};

export default ApplicationStatsCards;
